import {
	GET_ACTION_TEMPLATES,
	FETCH_ACTION_TEMPLATE,
	ADD_ACTION_TEMPLATE,
	EDIT_ACTION_TEMPLATE,
	DELETE_ACTION_TEMPLATE,
	CLEAR_ACTION_TEMPLATE,
	TEMPLATES_STATISTICS,
	TEMPLATES_BULK_ACTIONS,
	TEMPLATES_AVAILABLE_POSTMARK,
	TEMPLATES_AUTO_ASSIGN,
	TEMPLATE_VERIFY,
} from "constants/actions";

const initialState = {
	templates: [],
	statistics: null,
	availablePostmark: null,
	bulkActionsResult: null,
	autoAssignResult: null,
	verifyResult: null,
	pending: false,
};

export default function ActionTemplate(state = initialState, action) {
	switch (action.type) {
		case GET_ACTION_TEMPLATES:
			return {
				...state,
				templates: action.payload,
				pending: false,
			};

		case FETCH_ACTION_TEMPLATE:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case ADD_ACTION_TEMPLATE:
		case EDIT_ACTION_TEMPLATE:
			if (state.templates && Array.isArray(state.templates)) {
				const exists = state.templates.find((t) => t.id === action.payload.id);
				const templates = exists
					? state.templates.map((t) => (t.id === action.payload.id ? action.payload : t))
					: [...state.templates, action.payload];

				return {
					...state,
					templates,
					[action.payload.id]: action.payload,
					pending: false,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case DELETE_ACTION_TEMPLATE:
			return {
				...state,
				templates: (state.templates || []).filter((row) => row.id !== action.payload),
				pending: false,
			};

		case TEMPLATES_STATISTICS:
			return {
				...state,
				statistics: action.payload,
				pending: false,
			};

		case TEMPLATES_BULK_ACTIONS:
			return {
				...state,
				bulkActionsResult: action.payload,
				pending: false,
			};

		case TEMPLATES_AVAILABLE_POSTMARK:
			return {
				...state,
				availablePostmark: action.payload,
				pending: false,
			};

		case TEMPLATES_AUTO_ASSIGN:
			return {
				...state,
				autoAssignResult: action.payload,
				pending: false,
			};

		case TEMPLATE_VERIFY:
			return {
				...state,
				verifyResult: action.payload,
				pending: false,
			};

		case CLEAR_ACTION_TEMPLATE:
			return initialState;

		default:
			return state;
	}
}

